import React, { useMemo, useState } from "react";
import { Button, Drawer, List, Popconfirm, Skeleton, Tag } from "antd";
import moment from 'moment';
import { useGetVersions } from "./hooks/useGetVersions";
import { useActivatePrompt } from "./hooks/useActivatePrompt";
import { DeploymentUnitOutlined } from "@ant-design/icons";
import { StyledItem } from "./styled";

import { TOOLTIP_LABEL_FORMAT } from '@src/utils/constants';
import EditDrawer from "./EditDrawer";


export const ListItem = ({ item, setShowEditDrawer, setSelectedVersionId }) => {
  const activateMutation = useActivatePrompt({});

  const handleRecordClick = () => {
    setSelectedVersionId(item.id);
    setShowEditDrawer(true);
  };

  const handleDeploy = () => {
    activateMutation.mutateAsync({ id: item.id });
  };

  return (
    <List.Item
      key={item.id}
      extra={
        <div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
          <div>
            <span style={{ color: 'rgb(144, 144, 144)' }}>v{item.id}</span>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Popconfirm
              title="Deploy system prompt"
              description="Are you sure you want to activate this prompt?"
              onConfirm={handleDeploy}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="primary"
                size="small"
                icon={<DeploymentUnitOutlined />}
                title="Activate"
              />
            </Popconfirm>
          </div>
        </div>
      }
    >
      <List.Item.Meta
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <StyledItem onClick={handleRecordClick}>
              {item.version_notes.length > 100 ? `${item.version_notes.slice(0, 75)}...` : item.version_notes}
            </StyledItem>
          </div>
        }
        description={
          <div style={{ display: 'flex', gap: 8 }}>
            <span>
              {moment(item.created_at).format(TOOLTIP_LABEL_FORMAT)}
              <br />
              {item.created_by_username || item.created_by}
            </span>
            {item.is_active && <Tag style={{ height: 20 }} color="green">active</Tag>}
          </div>
        }
      />
    </List.Item>
  );
};


export const VersionsDrawer = ({ selectedPrompt, showVersionDrawer, setShowVersionsDrawer }) => {
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [selectedVersionId, setSelectedVersionId] = useState(null);

  const { isFetching, data = [] } = useGetVersions({
    promptId: selectedPrompt?.id,
    enabled: showVersionDrawer,
  });

  const handleClose = () => {
    setShowVersionsDrawer(false);
  }

  const editableVersion = useMemo(() => {
    return selectedVersionId ? data.find((item) => item.id === selectedVersionId) : null;
  }, [data, selectedVersionId]);

  return (
    <Drawer
      title="Versions"
      width={420}
      closable={false}
      onClose={handleClose}
      open={showVersionDrawer}
      placement="left"
    >
      {isFetching ? (
        <Skeleton active />
      ) : (
        <List
          size="small"
          dataSource={data}
          renderItem={(item) => (
            <ListItem
              item={item}
              setShowEditDrawer={setShowEditDrawer}
              setSelectedVersionId={setSelectedVersionId}
            />
          )}
        />
      )}

      <EditDrawer
        key={editableVersion?.id}
        showEditDrawer={showEditDrawer}
        selectedPrompt={selectedPrompt}
        editableVersion={editableVersion}
        setShowEditDrawer={setShowEditDrawer}
      />
    </Drawer>
  )
}

export default VersionsDrawer;
